import { rarePicks } from "@/mocks/comics";

export default function RarePicks() {
  const [featured, ...rest] = rarePicks;

  return (
    <section id="rare" className="scroll-mt-20 bg-accent-950/95 py-14 text-background-50 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-accent-300">
              <span className="h-px w-6 bg-accent-400"></span>
              绝版资源 · 考古精选
            </p>
            <h2 className="text-2xl md:text-4xl">被时光封存的绝版之作</h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100/80 md:text-base">
              这些老版本画稿与片源在主流平台几乎绝迹，考古团队逐帧修复、标注来源，
              只为把失落的童年碎片拼回原貌。
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/20 px-4 py-1.5 text-xs whitespace-nowrap">
            <i className="ri-treasure-map-line text-accent-300"></i>
            每周更新绝版考古成果
          </span>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <article className="cover-fade group relative overflow-hidden rounded-lg lg:col-span-2 lg:row-span-2">
            <img
              src={featured.cover}
              alt={`${featured.title} 绝版资源考古封面`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
            <div className="relative flex h-full min-h-[340px] flex-col justify-end p-6 md:min-h-[460px] md:p-8">
              <span className="mb-3 inline-flex w-fit items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs whitespace-nowrap text-background-50">
                <i className="ri-award-line"></i>
                {featured.tag} · 镇站考古
              </span>
              <h3 className="font-heading text-2xl md:text-3xl">{featured.title}</h3>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-background-100/90">
                {featured.note}
              </p>
              <button
                type="button"
                className="mt-4 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-medium text-accent-900 transition-colors hover:bg-accent-100"
              >
                进入考古档案
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </article>

          {rest.map((p) => (
            <article
              key={p.id}
              className="group flex gap-4 overflow-hidden rounded-lg bg-background-50/10 p-3 backdrop-blur-sm transition-colors hover:bg-background-50/15"
            >
              <div className="cover-fade relative h-28 w-24 shrink-0 overflow-hidden rounded-md">
                <img
                  src={p.cover}
                  alt={`${p.title} 绝版资源考古封面`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="flex min-w-0 flex-1 flex-col justify-center">
                <span className="mb-1 inline-flex w-fit rounded-full bg-accent-500/90 px-2 py-0.5 text-[11px] whitespace-nowrap text-background-50">
                  {p.tag}
                </span>
                <h3 className="font-heading text-lg leading-snug">{p.title}</h3>
                <p className="mt-1 line-clamp-3 text-xs leading-relaxed text-background-100/75">
                  {p.note}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}